import { client } from '@/services/beef'

/**
 * Validates a email verification token
 */
export const validateEmailVerificationToken = (data: { token: string }) => {

  return client.validateEmailVerificationToken({
    body: data,
  })
    .catch((error) => {

      if (error.response) {
        if (error.response.status === 403) {
          throw new Error('TokenInvalid')
        }
      }

      throw error
    })
}
